import { RouteType } from '../components/core/Route';
import AlimTalkTask from '../pages/alimTalkTask';
import AlimTalkTemplate from '../pages/alimTalkTemplate';
import AppDialog from '../pages/appDialog';
import AppPush from '../pages/appPush';
import AssignedTask from '../pages/assignedTask';
import Bill from '../pages/bill';
import Book from '../pages/book';
import BrandMessageTask from '../pages/brandMessageTask';
import BrandMessageTemplate from '../pages/brandMessageTemplate';
import CodepushVersion from '../pages/codepushVersion';
import Dashboard from '../pages/dashboard';
import DeliveryOrder from '../pages/deliveryOrder';
import EnigmaBuilder from '../pages/enigmaBuilder';
import FormulaSet from '../pages/formulaSet';
import Login from '../pages/login';
import MathKingUser from '../pages/mathKingUser';
import MyOrganization from '../pages/myorganization';
import Organization from '../pages/organization';
import Permission from '../pages/permission';
import ProblemGenerator from '../pages/problemGenerator';
import Product from '../pages/product';
import ProductPeriodOrder from '../pages/productPeriodOrder';
import Promotion from '../pages/promotion';
import SalesRecord from '../pages/salesRecord';
import SchoolExamProblem from '../pages/schoolExamProblem';
import SchoolExamSource from '../pages/schoolExamSource';
import ScrapSource from '../pages/scrapSource';
import StoreStuff from '../pages/storeStuff';
import Stuff from '../pages/stuff';
import Task from '../pages/task';
import TypingAutomationScript from '../pages/typingAutomationScript';
import Workbook from '../pages/workbook';

type RouteGroupType = {
  id: string;
  name?: string;
  routes: RouteType[];
};

export const unauthenticatedRoutes: RouteType[] = [...Login.routes];

export const authenticatedRouteGroups: RouteGroupType[] = [
  { id: 'main', routes: [...Dashboard.routes, ...Permission.routes] },
  {
    id: 'mathKingUser',
    name: '수학대왕 CS',
    routes: [...MathKingUser.routes],
  },
  {
    id: 'mathContents',
    name: '학습 콘텐츠',
    routes: [
      ...ScrapSource.routes,
      ...TypingAutomationScript.routes,
      ...Task.routes,
      ...AssignedTask.routes,
      ...ProblemGenerator.routes,
      ...Workbook.routes,
      // OX 퀴즈 · OX 퀴즈 맛보기는 앱 3.7.0 에서 진입점이 전부 빠졌다(학습 탭 아이콘·개념집).
      // 운영을 내리려고 메뉴에서 뺀다. 페이지 코드는 되살릴 때를 위해 남긴다 (2026-09-11)
      ...SchoolExamProblem.routes,
      ...SchoolExamSource.routes,
      ...FormulaSet.routes,
    ],
  },
  {
    id: 'event',
    name: '이벤트',
    routes: [
      ...Stuff.routes,
      ...AppDialog.routes,
      ...AppPush.routes,
      ...AlimTalkTemplate.routes,
      ...AlimTalkTask.routes,
      ...BrandMessageTemplate.routes,
      ...BrandMessageTask.routes,
    ],
  },
  {
    id: 'product',
    name: '상품',
    routes: [
      ...StoreStuff.routes,
      ...Product.routes,
      ...ProductPeriodOrder.routes,
      ...Promotion.routes,
      ...Bill.routes,
    ],
  },
  { id: 'deliveryOrder', name: '결제 · 배송', routes: [...DeliveryOrder.routes] },
  { id: 'development', name: '개발', routes: [...CodepushVersion.routes, ...EnigmaBuilder.routes] },
  {
    id: 'classroom',
    name: '클래스',
    routes: [...SalesRecord.routes, ...Organization.routes, ...MyOrganization.routes, ...Book.routes],
  },
];

export const authenticatedRoutes: RouteType[] = authenticatedRouteGroups.reduce<RouteType[]>(
  (result, { routes }) => [...result, ...routes],
  [],
);

export const routes: RouteType[] = [...unauthenticatedRoutes, ...authenticatedRoutes];
